import { getProductSpecificDiscount, isProductSpecificDiscount } from '../priceRules/priceRulesHelpers';
function productGroupsGetTotalPriceAndDiscount(product) {
    if (!product)
        return { price: 0, discountValue: 0 };
    let price = product.priceStructure.priceInGroup || 0;
    let discountValue = isProductSpecificDiscount(product.discount)
        ? getProductSpecificDiscount({ price, discount: product.discount })
        : 0;
    for (let group of product.groups) {
        const item = group.products.find((x) => x.id === group.options.defaultSelected);
        const result = productGroupsGetTotalPriceAndDiscount(item);
        price += result.price;
        discountValue += result.discountValue;
    }
    return { price, discountValue };
}
export { productGroupsGetTotalPriceAndDiscount };
